<ui-organism-title-logos/>
<ui-organism-main-nav [mainText]="pageTitle" />

<ui-atom-spacer />
<div class="forms-header">
  <ui-atom-text type="medium" [text]="'beneficiaryDetail.subtitle' | translate"></ui-atom-text>
</div>
<ui-atom-global-search (search)="onGlobalSearch($event)" />

<div class="beneficiary-detail">
  <section class="forms-table">
    <ui-molecule-mat-table
      [data]="formsData"
      [columns]="formsColumns"
      [paginator]="true"
      paginationMode="server"
      [totalItems]="totalItems"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [isLoading]="isLoading"
      [actions]="formsActions"
      [showClearFiltersButton]="false"
      [showGlobalSearch]="false"
      [exportFileName]="'beneficiary-forms'"
      [useExportColumnPicker]="true"
      (actionClick)="onFormAction($event)"
      (rowClick)="onRowClick($event)"
      (pageChange)="onPageChange($event)"
      (exportAllDataWithColumns)="onExportAllForms($event)"
    >
    </ui-molecule-mat-table>
  </section>
</div>
